import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "ReInviteUser.js";

function* workerReInviteUser(payLoad) {
  console.log(TAG, "RE INvite User : " + JSON.stringify(payLoad));
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.REINVITE_USER,
      payLoad.data
    );
    yield put(memberAction.reInviteUserSuccess(response));
  } catch (error) {
    console.error(TAG, "Worker get country failed: " + error.message);
    yield put(memberAction.reInviteUserFailed(error.message));
    // throw new Error("Error: inside saga", JSON.stringify(error));
  }
}

export const watchReInviteUser = takeLatest(
  memberType.REINVITE_USER_REQUESTED,
  workerReInviteUser
);
